export default __webpack_public_path__ + "static/media/KB__CV.d4ce9e56.pdf";